import { produce } from "immer";
import { theme } from "../../theme/theme";
import { CLEAR_ALL_ERROR_MESSAGE, CLEAR_ERROR_MESSAGE, LOAD_API_DATA, SET_API_DATA, SET_ERROR_MESSAGE, SET_FORM_OPTION, SET_FORM_VALUE, SET_FORM_VALUEOBJ } from "./dataDomain.type";
const INITAL_STATE = {
    apiData: {
        supplyDomain: {
            status: "idle",
            data: {},
            isError: false,
            errorMessage: "",
            loading: false
        },
        masterDataDomain: {
            status: "idle",
            data:{},
            isError: false,
            errorMessage: "",
            loading: false
        },
        demandDomain: {
            status: "idle",
            data:{},
            isError: false,
            errorMessage: "",
            loading: false
        },
        rNDDomain: {
            status: "idle",
            data:{},
            isError: false,
            errorMessage: "",
            loading: false
        },
        pnODomain: {
            status: "idle",
            data:{},
            isError: false,
            errorMessage: "",
            loading: false
        },
        financeDomain: {
            status: "idle",
            data:{},
            isError: false,
            errorMessage: "",
            loading: false
        },
        subDomain: {
            status: "idle",
            data:[],
            isError: false,
            errorMessage: "",
            loading: false
        }

    },
    formData: {
        country: {
            value: "",
            valueAsObj: {},
            options: [{ country: 'USA' },],
            loading: false,
            isError: false,
            errorMessage: ""
        },
        domainActiveIndex: {
            value: 0,
            valueAsObj: {},
            options: [{ country: 'USA' },],
            loading: false,
            isError: false,
            errorMessage: ""
        }

    }

}

const dataDomainReducer = (state = INITAL_STATE, { type, payload }) => {
    switch (type) {
        case SET_FORM_VALUE: {
            return produce(state, (draft) => {
                 
                draft.formData[payload.formField].value = payload.value
            });
        }
        case SET_FORM_VALUEOBJ: {
            return produce(state, (draft) => {
                draft.formData[payload.formField].valueAsObj = payload.valueAsObj
            });
        }
        case SET_ERROR_MESSAGE: {
            return produce(state, (draft) => {
                draft.formData[payload.formField].isError = payload.isError
                draft.formData[payload.formField].errorMessage = payload.errorMessage
            });
        }
        case CLEAR_ERROR_MESSAGE: {
            return produce(state, (draft) => {
                draft.formData[payload.formField].isError = false
                draft.formData[payload.formField].errorMessage = ""
            });
        }
        case CLEAR_ALL_ERROR_MESSAGE: {
            return produce(state, (draft) => {
                Object.keys(draft.formData).forEach((val) => {
                    draft.formData[val].isError = false
                    draft.formData[val].errorMessage = ""
                })

            });
        }
        case LOAD_API_DATA:
            return produce(state, (draft) => {
                draft.apiData[payload.apiField].loading = true
                draft.apiData[payload.apiField].status = "loading"
            })
        case SET_API_DATA:
            return produce(state, (draft) => {
                draft.apiData[payload.apiField].loading = false;
                draft.apiData[payload.apiField].status =
                    payload.status !== undefined && payload.status !== null
                        ? payload.status
                        : "success";
                draft.apiData[payload.apiField].data = payload.data;
            });
        case SET_FORM_OPTION:
            return produce(state, (draft) => {
                draft.formData[payload.formField].loading = false;
                draft.formData[payload.formField].options = payload.data;
            });
        // Return the current state if no action matches
        default:
            return state;
    }
}
export default dataDomainReducer;